const JAPANESE_ORDINAL = 'イロハニホヘトチリヌルヲワカ';

export const japaneseOrdinal = (index: number): string | undefined => JAPANESE_ORDINAL[index];

export const SPECIFIED_WORKS = [
  { code: 'handlingHotObjects', label: '多量の高熱物体を取り扱う業務及び著しく暑熱な場所における業務' },
  { code: 'handlingColdObjects', label: '多量の低温物体を取り扱う業務及び著しく寒冷な場所における業務' },
  { code: 'handlingHarmfulRadiation', label: 'ラジウム放射線、エツクス線その他の有害放射線にさらされる業務' },
  { code: 'handlingDust', label: '土石、獣毛等のじんあい又は粉末を著しく飛散する場所における業務' },
  { code: 'handlingAbnormalPressure', label: '異常気圧下における業務' },
  { code: 'handlingVibration', label: 'さく岩機、鋲打機等の使用によつて、身体に著しい振動を与える業務' },
  { code: 'handlingHeavyObjects', label: '重量物の取扱い等重激な業務' },
  { code: 'handlingLoudNoise', label: 'ボイラー製造等強烈な騒音を発する場所における業務' },
  { code: 'workingUnderground', label: '坑内における業務' },
  { code: 'nightShift', label: '深夜業を含む業務' },
  {
    code: 'handlingHarmfulSubstances',
    label:
      '水銀、砒素、黄りん、弗化水素酸、塩酸、硝酸、硫酸、青酸、か性アルカリ、石炭酸その他これらに準ずる有害物を取り扱う業務'
  },
  {
    code: 'handlingHarmfulGas',
    label:
      '鉛、水銀、クロム、砒素、黄りん、弗化水素、塩素、塩酸、硝酸、亜硫酸、硫酸、一酸化炭素、二硫化炭素、青酸、ベンゼン、アニリンその他これらに準ずる有害物のガス、蒸気又は粉じんを発散する場所における業務'
  },
  { code: 'handlingPathogens', label: '病原体によつて汚染のおそれが著しい業務' },
  { code: 'other', label: 'その他厚生労働大臣が定める業務' }
] as const;
